import { useRouter } from 'next/router'
import MainNavItem from './MainNavItem'
import useActiveNavItemIndex from 'hooks/useActiveNavItemIndex'
import PropTypes from 'prop-types'
import classNames from 'classnames'

/**
 * @param {{
 *  condensed: boolean|false
 *  disabledRoutes: []
 *  items: []
 *  mobileNavOpen: boolean|false
 * }} props
 */
export default function Navigation({
  condensed = false,
  mobileNavOpen = false,
  items,
  disabledRoutes = [],
  disabledElements = [],
  mobileSubnav,
  className,
  titleVariant = 'bodyLg',
  titleMobileVariant = 'bodyLg',
  subNavClassName,
  titleClassName,
  subNavTitleClassName,
}) {
  let [activeItemIndex] = useActiveNavItemIndex()
  const router = useRouter() || {}

  const filterSubNavsIfAllRoutesAreDisabled = (subNavs) => {
    return (
      subNavs
        .filter((subNavMain) => {
          let urls = []
          if (!subNavMain?.subNavMenus) return true
          //Gets a list of urls contained within sub menu Items
          for (let subNav of subNavMain.subNavMenus[0].menuItems) {
            if (subNav?.url) {
              urls.push(subNav.url)
            }
          }

          //Removes sub menus with no routes available
          return !(
            urls.filter((url) => {
              return !disabledRoutes.includes(url)
            }).length === 0
          )
        })
        //This mapping logic returns JSX corresponding to sub menus available
        .map((props, i) => (
          <MainNavItem
            itemIndex={i}
            key={i}
            currentPathname={router.pathname}
            {...props}
            disabledRoutes={disabledRoutes}
            disabledElements={disabledElements}
            titleVariant={titleVariant}
            titleMobileVariant={titleMobileVariant}
            subNavClassName={subNavClassName}
            titleClassName={titleClassName}
            subNavTitleClassName={subNavTitleClassName}
          />
        ))
    )
  }

  return (
    <nav
      className={classNames(
        'bg-white border-t-neutral-75 border-sold border-b-0 border-x-0 h-full overflow-scroll pb-40 pt-[54px] fixed -right-full [transition:transform_250ms_cubic-bezier(0.4,_0,_0.2,_1)] w-full',
        'data-[mobile-nav-open=true]:-translate-x-full',
        '[&>ul]:flex [&>ul]:flex-col [&>ul]:list-none [&>ul]:m-0 [&>ul]:p-0',
        'lg:border-none lg:border-0 lg:h-full lg:[overflow:initial] lg:py-0 lg:relative lg:right-0 lg:top-0 lg:w-auto lg:[transition:none]',
        'lg:data-[mobile-nav-open=true]:transform-none',
        'lg:[&>ul]:items-stretch lg:[&>ul]:h-full lg:[&>ul]:flex-row',
        className
      )}
      data-condensed={condensed}
      data-mobile-nav-open={mobileNavOpen}
      data-subnav-open={activeItemIndex >= 0}
    >
      <ul>{filterSubNavsIfAllRoutesAreDisabled(items)}</ul>
      {mobileSubnav}
    </nav>
  )
}

Navigation.propTypes = {
  condensed: PropTypes.bool,
  disabledRoutes: PropTypes.array,
  disabledElements: PropTypes.object,
  mobileNavOpen: PropTypes.bool,
  items: PropTypes.array.isRequired,
}
